import { call, put } from 'redux-saga/effects';
import { BuyersAsyncActions } from 'store/actions/buyers';
import { apiCall } from 'utils/apiCall';
import { toast } from 'react-toastify';

function* updateBuyerProfile(action) {
  const {
    UpdateBuyerProfile: {
      Actions: { SUCCESS, FAILURE },
    },
  } = BuyersAsyncActions;
  const {
    payload: { buyerProfile },
  } = action;

  try {
    const response = yield call(apiCall, `/buyerProfiles/${buyerProfile.id}`, 'put', buyerProfile);
    yield put(SUCCESS(response.data));
  } catch (error) {
    toast.error(error.message);
    yield put(FAILURE(error));
  }
}

export default updateBuyerProfile;
